import React, { useContext, lazy } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import track from 'react-tracking';
import Home from '../containers/home';
import Privacy from '../containers/privacy';
import TermsAndConditions from '../containers/terms-and-conditions';
import Scrooltotop from '../components/scrollToTop/index';
import Faq from '../containers/faq';
import ReportNotAvailable from '../containers/report-not-available';
import BuyNow from '../containers/buy-now';
import SampleReport from '../components/sampleReport/SampleReport';
import PlanDetailsBuyNow from '../components/plan-details-buy-now';
import AboutWiseDrive from '../containers/about-wisedrive/index';
import ServiceAndMaintenance from '../containers/ServiceAndMainentanancePolicy';
import Cancellation from '../containers/CancellationAndReturnPolicy/index';
import BuyBackPolicy from '../containers/buybackPolicy';
import WarrantyPolicy from '../containers/warranty-policy';
import PlanBuyStatus from '../components/payment-status';
import SampleReportNew from '../components/sampleReport/SampleReportNew';
import EditReport from '../components/sampleReport/EditReport/EditReport';
import OTPVerification from '../components/sampleReport/OtpVerification';
import Terms from '../containers/terms';

import { MyContext } from '../context';
import RedirectBasedOnCountry from './redirectBAsedOnCountry';
import CountryHome from '../containers/countrySelect';
// import LeadGeneration from '../containers/leadGeneration';
const LeadGeneration = lazy(() => import('../containers/leadGeneration'));
const PaymentSuccess = lazy(() => import('../containers/payment-success'));

const AppRoutes = () => {
  const { country } = useContext(MyContext);

  const withCountryRoutes = (path, element) => {
  const countries = ['in', 'id', 'my', 'th'];
  return [
    <Route key={path} path={path} element={element} />,
    ...countries.map((code) => (
      <Route key={`${code}${path}`} path={`/${code}${path}`} element={element} />
    )),
  ];
};

  return (
    <Router>
      <Scrooltotop />
      <Routes>
        <Route path="*" element={<Navigate to="/cs" replace />} />
        {/* New routes start */}
        <Route exact path="/googleadsleadgen" element={<LeadGeneration />} />
        <Route
          exact
          path="/googleadsleadgen/success"
          element={<PaymentSuccess />}
        />
        <Route exact path="/sample-report" element={<SampleReport />} />
        <Route exact path="/inspection-report" element={<SampleReportNew />} />
        <Route exact path="/in/edit-report/:id" element={<EditReport />} />
        <Route exact path="/id/edit-report/:id" element={<EditReport />} />
        <Route exact path="/my/edit-report/:id" element={<EditReport />} />
        <Route exact path="/th/edit-report/:id" element={<EditReport />} />
        <Route exact path="/report/verify" element={<OTPVerification />} />

        {/* plan-details-buy-now Routes */}
        {/* <Route
          exact
          path="/plan-details-buy-now"
          element={<PlanDetailsBuyNow />}
        />
        <Route
          exact
          path="/in/plan-details-buy-now"
          element={<PlanDetailsBuyNow />}
        />
        <Route
          exact
          path="/id/plan-details-buy-now"
          element={<PlanDetailsBuyNow />}
        />
        <Route
          exact
          path="/my/plan-details-buy-now"
          element={<PlanDetailsBuyNow />}
        />
        <Route
          exact
          path="/th/plan-details-buy-now"
          element={<PlanDetailsBuyNow />}
        /> */}
        {withCountryRoutes('/plan-details-buy-now', <PlanDetailsBuyNow />)}

        {/* buy-now ROutes */}
        {/* <Route exact path="/buy-now" element={<BuyNow />} />
        <Route exact path="/in/buy-now" element={<BuyNow />} />
        <Route exact path="/id/buy-now" element={<BuyNow />} />
        <Route exact path="/my/buy-now" element={<BuyNow />} />
        <Route exact path="/th/buy-now" element={<BuyNow />} /> */}
        {withCountryRoutes('/buy-now', <BuyNow />)}

        {/* about-wisedrive Routes */}
        {/* <Route exact path="/about-wisedrive" element={<AboutWiseDrive />} />
        <Route exact path="/in/about-wisedrive" element={<AboutWiseDrive />} />
        <Route exact path="/id/about-wisedrive" element={<AboutWiseDrive />} />
        <Route exact path="/my/about-wisedrive" element={<AboutWiseDrive />} />
        <Route exact path="/th/about-wisedrive" element={<AboutWiseDrive />} /> */}
        {withCountryRoutes('/about-wisedrive', <AboutWiseDrive />)}

        <Route exact path="/payment-status" element={<PlanBuyStatus />} />
        {/* New routes end */}

        {/* privacy routes */}
        {/* <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/in/privacy" element={<Privacy />} />
        <Route exact path="/id/privacy" element={<Privacy />} />
        <Route exact path="/my/privacy" element={<Privacy />} />
        <Route exact path="/th/privacy" element={<Privacy />} /> */}
        {withCountryRoutes('/privacy', <Privacy />)}
        {/* privacy routes end */}
        {/* Inspection-terms-and-conditions routes */}
        {/* <Route
          exact
          path="/inspection-terms-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route
          exact
          path="/in/inspection-terms-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route
          exact
          path="/id/inspection-terms-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route
          exact
          path="/my/inspection-terms-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route
          exact
          path="/th/inspection-terms-and-conditions"
          element={<TermsAndConditions />}
        /> */}
        {withCountryRoutes('/terms-and-conditions', <Terms />)}

        {/* warrantyPolicy routes */}
        {/* <Route exact path="/warrantyPolicy" element={<WarrantyPolicy />} />
        <Route exact path="/in/warrantyPolicy" element={<WarrantyPolicy />} />
        <Route exact path="/id/warrantyPolicy" element={<WarrantyPolicy />} />
        <Route exact path="/my/warrantyPolicy" element={<WarrantyPolicy />} />
        <Route exact path="/th/warrantyPolicy" element={<WarrantyPolicy />} /> */}
        {withCountryRoutes('/warrantyPolicy', <WarrantyPolicy />)}

        {/* terms-and-conditions Routes */}
        {/* <Route exact path="/terms-and-conditions" element={<Terms />} />
        <Route exact path="/in/terms-and-conditions" element={<Terms />} />
        <Route exact path="/id/terms-and-conditions" element={<Terms />} />
        <Route exact path="/my/terms-and-conditions" element={<Terms />} />
        <Route exact path="/th/terms-and-conditions" element={<Terms />} /> */}
        {withCountryRoutes('/inspection-terms-and-conditions', <TermsAndConditions />)}


        {/* service-and-maintenance routes */}
        {/* <Route
          exact
          path="/service-and-maintenance"
          element={<ServiceAndMaintenance />}
        />
        <Route
          exact
          path="/in/service-and-maintenance"
          element={<ServiceAndMaintenance />}
        />
        <Route
          exact
          path="/id/service-and-maintenance"
          element={<ServiceAndMaintenance />}
        />
        <Route
          exact
          path="/my/service-and-maintenance"
          element={<ServiceAndMaintenance />}
        />
        <Route
          exact
          path="/th/service-and-maintenance"
          element={<ServiceAndMaintenance />}
        /> */}
        {withCountryRoutes('/service-and-maintenance', <ServiceAndMaintenance />)}

        {/* cancellation_refund_policy Routes */}
        {/* <Route
          exact
          path="/cancellation_refund_policy"
          element={<Cancellation />}
        />
        <Route
          exact
          path="/in/cancellation_refund_policy"
          element={<Cancellation />}
        />
        <Route
          exact
          path="/id/cancellation_refund_policy"
          element={<Cancellation />}
        />
        <Route
          exact
          path="/my/cancellation_refund_policy"
          element={<Cancellation />}
        />
        <Route
          exact
          path="/th/cancellation_refund_policy"
          element={<Cancellation />}
        /> */}
        {withCountryRoutes('/cancellation_refund_policy', <Cancellation />)}

        {/* faq Routes */}
        {/* <Route exact path="/faq" element={<Faq />} />
        <Route exact path="/in/faq" element={<Faq />} />
        <Route exact path="/my/faq" element={<Faq />} />
        <Route exact path="/id/faq" element={<Faq />} />
        <Route exact path="/th/faq" element={<Faq />} /> */}
        {withCountryRoutes('/faq', <Faq />)}

        {/* buybackPolicy Routes */}
        {/* <Route exact path="/buybackPolicy" element={<BuyBackPolicy />} />
        <Route exact path="/in/buybackPolicy" element={<BuyBackPolicy />} />
        <Route exact path="/id/buybackPolicy" element={<BuyBackPolicy />} />
        <Route exact path="/my/buybackPolicy" element={<BuyBackPolicy />} />
        <Route exact path="/th/buybackPolicy" element={<BuyBackPolicy />} /> */}
        {withCountryRoutes('/buybackPolicy', <BuyBackPolicy />)}

        {/* privacy-policy Routes */}
        {/* <Route
          exact
          path="/privacy-policy"
          element={<Navigate to="/privacy" />}
        />
        <Route
          exact
          path="/in/privacy-policy"
          element={<Navigate to="/privacy" />}
        />
        <Route
          exact
          path="/id/privacy-policy"
          element={<Navigate to="/privacy" />}
        />
        <Route
          exact
          path="/my/privacy-policy"
          element={<Navigate to="/privacy" />}
        />
        <Route
          exact
          path="/th/privacy-policy"
          element={<Navigate to="/privacy" />}
        /> */}
        {withCountryRoutes('/privacy-policy', <Navigate to="/privacy" replace />)}

        {/* report-not-available Routes */}
        <Route
          exact
          path="/report-not-available/:id"
          element={<ReportNotAvailable />}
        />
        <Route path="/in" element={<Home />} />
        <Route path="/jp" element={<Home />} />
        <Route path="/my" element={<Home />} />
        <Route path="/id" element={<Home />} />
        <Route path="/th" element={<Home />} />
        <Route path="/cs" element={<CountryHome />} />
        <Route path="/" element={<RedirectBasedOnCountry />} />
      </Routes>
    </Router>
  );
};

const TrackedAppRoutes = track(
  { app: 'wisedrive website' },
  {
    // Dispatch tracking data to your analytics endpoint or console
    dispatch: (data) => {
      console.log(data);
      // Optionally push to your analytics service here
    },
  }
)(AppRoutes);

export default TrackedAppRoutes;
